module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_03_6DE79_1SF_HND.6424c661.jpg";